import React, { useState } from "react";
import PushNotification from "../components/PushNotification";
import LiveClass from "../components/LiveClass";
import ScheduledClasses from "../components/ScheduledClasses"; // New component
import EditPaymentConfigScreen from "../components/AmountModification"
import "../styles/AlertScheduleTabs.css";

const AlertScheduleTabs = () => {
  const [activeTab, setActiveTab] = useState("calendar");

  return (
    <div className="alert-tabs-container">
      <div className="tabs-header">
         <button
          className={activeTab === "push" ? "active" : ""}
          onClick={() => setActiveTab("push")}
        >
          Scheduled Notification
        </button>
        <button
          className={activeTab === "calendar" ? "active" : ""}
          onClick={() => setActiveTab("calendar")}
        >
          Live Classes
        </button>
        <button
          className={activeTab === "scheduled" ? "active" : ""}
          onClick={() => setActiveTab("scheduled")}
        >
          Scheduled Classes
        </button>
        <button
          className={activeTab === "amount" ? "active" : ""}
          onClick={() => setActiveTab("amount")}
        >
          Amount Modification
        </button>
      </div>

      <div className="tab-content">
        {activeTab === "push" && <PushNotification />}
        {activeTab === "calendar" && <LiveClass />}
        {activeTab === "scheduled" && <ScheduledClasses />}
        {activeTab === "amount" && <EditPaymentConfigScreen />}
      </div>
    </div>
  );
};

export default AlertScheduleTabs;
